import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { facebookAuthCallbackRequest } from '../../redux/slices/integrationsSlice';

/**
 * OAuth Callback Component
 * Handles OAuth redirects for all integration platforms (Facebook, Instagram, TikTok, etc.)
 */
const OAuthCallback: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    const code = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');
    const platform = sessionStorage.getItem('oauth_platform') || 'facebook';

    sessionStorage.removeItem('oauth_platform');

    if (code || error) {
      // If opened in popup, post message to opener window
      if (window.opener && !window.opener.closed) {
        const messageType = error ? `${platform}_AUTH_ERROR` : `${platform}_AUTH_SUCCESS`;
        const payload = {
          code: code || '',
          state: state || '',
          error,
          platform,
        };
        
        window.opener.postMessage(
          {
            type: messageType,
            payload,
          },
          window.location.origin
        );
        
        setTimeout(() => {
          window.close();
        }, 100);
      }
      else {
        dispatch(facebookAuthCallbackRequest({
          code: code || '',
          state: state || '',
          error,
          platform,
        }));
        
        navigate(`/integrations/${platform}`);
      }
    }
    else {
      console.error('OAuth callback missing required parameters');
      if (window.opener) {
        window.close();
      } else {
        navigate('/integrations');
      }
    }
  }, [searchParams, dispatch, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#000]">
      <div className="text-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary mx-auto mb-4"></div>
        <p className="text-gray-400 text-sm">Completing authentication...</p>
      </div>
    </div>
  );
};

export default OAuthCallback;
